<template>
    <div>
        <template>
            <v-row>
                <v-col cols="12" sm="2" class="pt-0">
                    <div>
                        <div style="display: flex;text-align: center;">
                            <v-icon class="mr-1" style="height: 36px;">mdi-calendar</v-icon>
                            <input v-model="startDateText" @click="showStartDatePicker = !showStartDatePicker"
                                label="Start Date" placeholder="시작일" class="search-input mb-0">

                        </div>
                    </div>
                    <div>
                        <v-date-picker class="datepicker" v-model="startDate" v-if="showStartDatePicker"
                            :allowed-dates="allowedStartDates" @input="handleStartDateInput"
                            color="#006cea"></v-date-picker>
                    </div>
                </v-col>


                <v-col cols="12" sm="2" class="pt-0">
                    <div>
                        <div style="display: flex;text-align: center;">
                            <v-icon class="mr-1" style="height: 36px;">mdi-calendar</v-icon>
                            <input v-model="endDateText" @click="showEndDatePicker = !showEndDatePicker"
                                label="End Date" placeholder="종료일" class="search-input mb-0">

                        </div>

                    </div>
                    <div>
                        <v-date-picker class="datepicker" v-model="endDate" v-if="showEndDatePicker"
                            :allowed-dates="allowedEndDates" @input="handleEndDateInput"
                            color="#006cea"></v-date-picker>
                    </div>
                </v-col>

                <div>

                    <TextButton buttonText="조회" @click="fetchData" isPrimary />

                </div>

                <v-col class="text-right mt-2">
                    <v-btn-toggle class="mr-3" v-model="chartType">

                        <TextButton buttonText="CDN" small value="CDN" />

                        <TextButton buttonText="Origin" small value="Origin" />

                    </v-btn-toggle>

                    <v-btn-toggle v-model="timeRange">

                        <TextButton buttonText="Last 6H" small value="6H" />

                        <TextButton buttonText="Today" small value="Today" />

                        <TextButton buttonText="Last 7Day" small value="7D" />

                        <TextButton buttonText="Last 30Day" small value="30D" />

                    </v-btn-toggle>
                    <IconButton icon="mdi-download" small class="ml-3" @click="downloadCSV" />
                </v-col>
            </v-row>
        </template>

        <v-row>
            <v-col cols="12" sm="6" class="pt-0 pl-0">
                <VodBandwidth :bandwidthData="bandwidthData" />

            </v-col>
            <v-col cols="12" sm="6" class="pt-0 pl-0 pr-0">
                <VodFlux :trafficData="trafficData" />

            </v-col>
            <!-- <v-col cols="12" sm="6" class="pt-0 pl-0">
                    <VodFluxHitRatey />
                </v-col>
                <v-col cols="12" sm="6" class="pt-0 pl-0 pr-0">
                    <VodRequest />
                </v-col> -->
        </v-row>


    </div>
</template>

<script>
import VodBandwidth from '@/components/statistics/vodstatistics/VodBandwidth.vue';
import VodFlux from '@/components/statistics/vodstatistics/VodFlux.vue';
import VodFluxHitRatey from '@/components/statistics/vodstatistics/VodFluxHitRatey.vue';
import VodRequest from '@/components/statistics/vodstatistics/VodRequest.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import StatisticsApi from "@/api/statistics/StatisticsApi";


export default {
    components: {
        TextButton,
        VodBandwidth,
        VodFlux,
        VodFluxHitRatey,
        VodRequest,
        IconButton,
    },
    data() {
        return {
            startDate: null,
            endDate: null,
            today: this.getDateString(new Date()),
            startDateText: '',
            endDateText: '',
            showStartDatePicker: false,
            showEndDatePicker: false,
            chartType: 'CDN',
            timeRange: 'Today',
            bandwidthData: [],
            trafficData: [],

        };
    },
    computed: {
        finalStartDate() {
            return this.startDate || this.today;
        },
        finalEndDate() {
            return this.endDate || this.today;
        }
    },
    watch: {
        startDate(newValue) {
            this.startDateText = newValue;
        },
        endDate(newValue) {
            this.endDateText = newValue;
        },
        chartType(newValue) {
            this.updateVodFlux();
        },
        timeRange(newValue) {
            this.setTimeRange(newValue);
        },
    },
    mounted() {
        this.setDefaultDates();
        //this.fetchData();
    },
    methods: {
        getDateString(date) {
            const offset = 9 * 60 * 60 * 1000;
            const kstDate = new Date(date.getTime() + offset);
            return kstDate.toISOString().substring(0, 10);
        },
        getDateTimeString(date) {
            const offset = 9 * 60 * 60 * 1000;
            const kstDate = new Date(date.getTime() + offset);
            return kstDate.toISOString().replace('T', ' ').substring(0, 19);
        },
        allowedStartDates(val) {
            if (this.endDate) {
                let endDate = new Date(this.endDate);
                let selectedDate = new Date(val);
                let minDate = new Date(endDate);
                minDate.setDate(minDate.getDate() - 90);
                return selectedDate <= new Date(this.today) && selectedDate >= minDate;
            }
            return new Date(val) <= new Date(this.today);
        },
        allowedEndDates(val) {
            if (this.startDate) {
                let startDate = new Date(this.startDate);
                let selectedDate = new Date(val);
                let maxDate = new Date(startDate);
                maxDate.setDate(maxDate.getDate() + 90);
                return selectedDate <= new Date(this.today) && selectedDate <= maxDate && selectedDate >= startDate;
            }
            return new Date(val) <= new Date(this.today);
        },
        handleStartDateInput(val) {
            // this.startDate = val;
            let date = new Date(val);
            this.startDate = this.getDateTimeString(date);
            this.showStartDatePicker = false;
            this.endDate = null;
        },
        handleEndDateInput(val) {
            let date = new Date(val);
            this.endDate = this.getDateTimeString(date);
            this.endDateText = this.endDate;
            this.showEndDatePicker = false;
        },
        updateVodFlux() {
            this.fetchData();
        },
        setTimeRange(range) {
            let end = new Date();
            let start = new Date();
            switch (range) {
                case '6H':
                    start.setHours(start.getHours() - 6);
                    this.startDate = this.getDateTimeString(start);
                    this.endDate = this.getDateTimeString(end);
                    break;
                case 'Today':
                    start.setHours(0, 0, 0, 0);
                    this.startDate = this.getDateTimeString(start);
                    this.endDate = this.getDateTimeString(end);
                    break;
                case '7D':
                    start.setDate(start.getDate() - 6);
                    this.startDate = this.getDateTimeString(start);
                    this.endDate = this.getDateTimeString(end);
                    break;
                case '30D':
                    start.setDate(start.getDate() - 29);
                    this.startDate = this.getDateTimeString(start);
                    this.endDate = this.getDateTimeString(end);
                    break;
            }
            this.startDateText = this.startDate;
            this.endDateText = this.endDate;
            this.updateVodFlux();
        },
        setDefaultDates() {
            this.setTimeRange('Today');
        },
        setChartType(type) {
            this.chartType = type;
        },
        async fetchData() {
            let start_time, end_time;
            if (this.timeRange === 'Today' || this.timeRange === '6H') {
                start_time = this.startDate;
                end_time = this.endDate;
            } else {
                start_time = this.startDate;
                end_time = this.endDate;
            }
            const interval = this.getInterval(new Date(start_time), new Date(end_time));
            const apiType = this.chartType;
            const metrics = ["bandwidth", "flux"];
            //console.log('params', { start_time, end_time, apiType, interval });
            const service = 'VOD';
            const params = {
                start_time,
                end_time,
                interval,
                service
            };

            try {
                const dataFetches = metrics.map(metric => {
                    const metricParams = { ...params, metric };
                    if (apiType === 'Origin') {
                        return StatisticsApi.originApi(metricParams);
                    } else {
                        return StatisticsApi.cdnApi(metricParams);
                    }
                });

                const responses = await Promise.all(dataFetches);
                this.bandwidthData = responses[0].DetailData.map(item => ({
                    Timestamp: item.Time,
                    Value: item.Value
                }));
                this.trafficData = responses[1].DetailData.map(item => ({
                    Timestamp: item.Time,
                    Value: item.Value
                }));

            } catch (error) {
                console.error("error", error);
            }
        },
        getInterval(startTime, endTime) {
            const diffInHours = (endTime - startTime) / (1000 * 60 * 60);
            if (diffInHours <= 24) {
                return 'hour';
            } else if (diffInHours <= 24 * 31) {
                return 'day';
            } else if (diffInHours <= 24 * 31 * 12) {
                return 'day';
            }
        },
        convertToCSV(data) {
            const array = [Object.keys(data[0])].concat(data);

            return array.map(row => {
                return Object.values(row).map(value => {
                    return typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value;
                }).join(',');
            }).join('\n');
        },

        downloadCSV() {
            let csvContent = "";

            const combinedData = [
                ...this.addDataMetric(this.bandwidthData, 'bandwidth'),
                ...this.addDataMetric(this.trafficData, 'traffic')
            ];

            csvContent += this.convertToCSV(combinedData);

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");

            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", "VodStatistics.csv");
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },

        addDataMetric(data, metric) {
            return data.map(item => ({
                Metric: metric,
                Time: item.Timestamp,
                Value: item.Value
            }));
        },

    },
}
</script>

<style scoped>
.datepicker {
    position: absolute;
    z-index: 22;
}
</style>